import Vue from 'vue';
import numeral from 'numeral';

// Reference: http://numeraljs.com/#format
Vue.filter('formatNumber', (value, format) => {
  return numeral(value).format(format);
});
